import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IInventoryItemDetails } from "../../../../../@types/InventoryItems";
import { PageHeader } from "../../../../../components/Headers/PageHeader";
import { ItemDetailsCard } from "../ItemDetailsCard";

import useItemSearch from "../../../../../hooks/api/Inventory/useItemSearch";
import * as S from "./styles";

export function ItemSearchDetails() {
  const { t } = useTranslation();
  const [itemDetail, setItemDetail] = useState({} as IInventoryItemDetails);

  const { itemId } = useParams();
  const { fetchItemDetails } = useItemSearch();

  // const numberOfGridCells = Math.floor((screenWidth - 160) / 376);

  const getItemDetails = async (itemId: string) => {
    setItemDetail({} as IInventoryItemDetails);
    const response = await fetchItemDetails(itemId);

    setItemDetail(response);
  };

  useEffect(() => {
    if (itemId) {
      getItemDetails(itemId);
    }
  }, [itemId]);

  return (
    <S.ItemDetailsContainer>
      <PageHeader
        title={t("itemDetails")}
        description={t("itemDetailsDescription")}
        refreshFunction={() => getItemDetails(itemId || "")}
        customBreadcrumbString={
          itemDetail.name ? itemDetail.name : t("itemDetail")
        }
      />

      <S.ItemDetailsCardsContainer>
        <ItemDetailsCard title={t("identification")} data={itemDetail} />
        <ItemDetailsCard title={t("pricing")} data={itemDetail} />
        <ItemDetailsCard title={t("stock")} search data={itemDetail} />
        <ItemDetailsCard title={t("location")} data={itemDetail} />
      </S.ItemDetailsCardsContainer>
    </S.ItemDetailsContainer>
  );
}
